import { createAsyncThunk } from "@reduxjs/toolkit";
import { client } from "api/client";
import { TwilioVideoGrant } from "@switcherstudio/switcher-api-client";

export const fetchToken = createAsyncThunk(
  "user/fetchToken",
  async (grant: TwilioVideoGrant) => {
    const token = await client.twilio_PostToken(grant);
    return token;
  }
);
